// Copyright (c) Bentley Systems
import DOMPurify from "dompurify";
import { EfFieldValidationTypeEnum } from "../../Helpers/enumerators";

// Markup-bearing types must not be sanitised or their tags are silently stripped.
const unsanitizedTypes: ReadonlySet<EfFieldValidationTypeEnum> = new Set([
  EfFieldValidationTypeEnum.Xml,
  EfFieldValidationTypeEnum.Json,
  EfFieldValidationTypeEnum.XmlOrJson,
]);

export function skipsSanitization(
  validationType: EfFieldValidationTypeEnum,
): boolean {
  return unsanitizedTypes.has(validationType);
}

export function sanitizeInputCurrentValue(currentStringValue: string): string {
  currentStringValue = DOMPurify.sanitize(currentStringValue);

  const ltGtEntities = /&(lt|gt);/;
  const isltGtEntitiesEntityUsed = ltGtEntities.test(currentStringValue);
  if (isltGtEntitiesEntityUsed) {
    // we need this e.g. operators <, >, <>
    currentStringValue = currentStringValue
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">");
  }
  return currentStringValue;
}
